import { Injectable } from '@angular/core';
declare var dataLayer: any[];

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private static EVENT_IMPRESION = 'productView';
  private static PRODUCT_TYPE = 'hotel';
  private static DATA_HTL = 'trackDataHTL';

  public mapping: any;

  constructor() {
    this.initialSetup();
  }

  public initialSetup() {
    this.mapping = {};
    const from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç';
    const to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuuNnCc';
    for (let i = 0, j = from.length; i < j; i++) {
      this.mapping[from.charAt(i)] = to.charAt(i);
    }
  }

  public trackEvent(params) {
    const event = {
      event: params.nonInteraction ? 'trackEventNonInteraction' : 'trackEvent',
      eventAction: params.action,
      eventCategory: 'HTL|' + params.section,
      eventLabel: params.label,
    };
    dataLayer.push(event);
  }

  public newTrackEvent(eventType: string, payload: any) {
    const event = {
      event: eventType,
      productType: AnalyticsService.PRODUCT_TYPE,
      products: payload,
    };
    dataLayer.push(event);
  }

  public productClick(params) {
    const event = {
      ecommerce: {
        click: {
          actionField: {
            list: 'HTL|Results',
          },
          products: [
            {
              category: 'HTL',
              id:
                'HTL|' +
                params.cityCode +
                '|' +
                params.hotelId +
                '|' +
                this.normalize(params.hotelName),
              list: 'HTL|Results',
              name: 'HTL',
              position: params.index,
              price: params.priceTotal,
              quantity: 1,
              variant: params.mealPlanCode,
            },
          ],
        },
      },
      event: 'productClick',
    };
    dataLayer.push(event);
  }

  public normalize(str) {
    let result;
    const ret = [];
    for (let i = 0, j = str.length; i < j; i++) {
      const c = str.charAt(i);
      if (this.mapping.hasOwnProperty(str.charAt(i))) {
        ret.push(this.mapping[c]);
      } else {
        ret.push(c);
      }
    }
    result = ret.join('');
    return encodeURI(result).replace(/%20/g, '+');
  }

  public trackProductImpressions(params: any) {
    const { data, query } = params;
    const productQuery = this.mapProductImpressionsQuery(data, query);
    const products = data.hotels.map((hotel, index) => ({
      ...hotel,
      position: data.pagination.offset + index + 1,
      query: productQuery,
    }));
    this.newTrackEvent(AnalyticsService.EVENT_IMPRESION, products);
  }

  public trackDataHTL(params: any) {
    const { data, query } = params;
    const dates = query.date ? query.date.split(',', 2) : null;
    const topFiveHotelsIds = data.hotels && data.hotels.slice(0, 5).map((hotel) => hotel.id);
    const event = {
      content_ids: topFiveHotelsIds,
      country: data.destination && data.destination.country ? data.destination.country.name : '',
      destination: data.destination && data.destination.city ? data.destination.city.name : '',
      endDate: dates ? dates[1] : null,
      event: AnalyticsService.DATA_HTL,
      passengers: this.getDecodedRooms(query.rooms).total,
      startDate: dates ? dates[0] : null,
    };

    dataLayer.push(event);
  }

  public mapProductImpressionsQuery(data, query) {
    const dates = query.date ? query.date.split(',', 2) : null;
    const productQuery = {
      appliedFilters: data.filters.applied,
      appliedOrders: {
        criteria: query.sortCriteria ? query.sortCriteria : '',
        sortBy: query.sortBy ? query.sortBy : '',
      },
      endDate: dates ? dates[1] : null,
      limit: data.pagination.limit,
      offset: data.pagination.offset,
      passengers: this.getDecodedRooms(query.rooms).total,
      startDate: dates ? dates[0] : null,
    };
    return productQuery;
  }

  public getDecodedRooms(rooms) {
    if (!rooms) {
      return {
        rooms: [
          {
            adults: 2,
            children: [],
          },
        ],
        total: 2,
        totalAdults: 2,
        totalChildren: 0,
      };
    }
    const distribution = {
      rooms: [],
      total: 0,
      totalAdults: 0,
      totalChildren: 0,
    };

    const roomsArray = rooms.split('!');

    roomsArray.forEach((room) => {
      const dist: any = {};
      room = room.split('-');
      dist.adults = parseInt(room.shift(), 10);
      dist.children = room.map((children) => parseInt(children, 10));
      distribution.totalAdults = distribution.totalAdults + dist.adults;
      distribution.totalChildren = distribution.totalChildren + dist.children.length;
      distribution.total = distribution.total + dist.adults + dist.children.length;
      distribution.rooms.push(dist);
    });

    return distribution;
  }
}
